export const params = {
  wordsDetect: {
    regexp: /([a-zA-Z0-9À-ž]+\S?)+/gu,

    // Groups:
    // {L} - Any kind of letter from any language.
    // {N} - Any kind of numeric character in any script.
    regexpObject: new RegExp("([\\p{L}\\p{N}]+\\S?)+", "gu"),
  },
}
